import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe that executes a function when the value changes
 *
 * @example
 * ```html
 * <span>{{value | wrapFn:fn:suffix}}</span>
 * ```
 *
 * ```typescript
 * const fn = (value: string, suffix: string) => `${value.toUpperCase()} + ${suffix}`;
 * ```
 *
 * Result: `VALUE + SUFFIX`
 *
 * @example
 * ```html
 * <span>{{value | wrapFn:fn}}</span>
 * ```
 */

@Pipe({
  name: 'wrapFn',
  pure: true,
  standalone: true,
})
export class WrapFnPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform<T, FN extends (input: T, ...args: any[]) => any>(value: T, wrapperFunction: FN, ...args: any[]): ReturnType<FN> {
    if (!wrapperFunction) {
      return null;
    }

    return wrapperFunction(value, ...args);
  }
}
